// AuthGuard.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthTalentGuard = ({ children }) => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("user"); 

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/talent/dashboard");
    }
  }, [isLoggedIn, navigate]);

  return !isLoggedIn ? children : null;
};

export default AuthTalentGuard;
